import { render, staticRenderFns } from "./SwitchLocale.vue?vue&type=template&id=651fbe79&scoped=true"
import script from "./SwitchLocale.vue?vue&type=script&lang=js"
export * from "./SwitchLocale.vue?vue&type=script&lang=js"
import style0 from "./SwitchLocale.vue?vue&type=style&index=0&id=651fbe79&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_e639414b8f28593ae71b2a471b1115a5/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651fbe79",
  null
  
)

export default component.exports